import React from 'react'
import Router from './routes/Router'
import { notification, ConfigProvider } from 'antd'
import './App.css'
import { LicenseInfo, ptBR } from '@mui/x-data-grid-pro'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { ptBR as coreptBR } from '@material-ui/core/locale'
import GeneralContextProvider from './context/GeneralContext/GeneralContextProvider'
import { default as ptBR_antd } from 'antd/es/locale/pt_BR'
import styles from './services/styles'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";


const { COLORS } = styles

const theme = createTheme(
  { palette: { primary: { main: COLORS.GREEN[500] }, }, },
  ptBR,
  coreptBR,
)

LicenseInfo.setLicenseKey(
  '1ef6d6c91f74abe50c0b422b86df9bdaT1JERVI6Mjk3NTksRVhQSVJZPTE2NjM4NzA5MzYwMDAsS0VZVkVSU0lPTj0x',
)

window.alert = (message, type = 'info', title = 'Atenção!', duration = 3, key = 'unique') => {
  notification[type]({
    key,
    message: title,
    description: message,
    placement: 'topRight',
    duration
  })
}

function App() {

  return (
    <ConfigProvider
      locale={ptBR_antd}
      theme={{
        token: {
          colorPrimary: COLORS.GREEN[600],
          borderRadius: 4,
          colorTextDisabled: COLORS.GREEN[900],
        },
      }}
    >
      <ThemeProvider theme={theme}>
        <GeneralContextProvider>
          <Router />
        </GeneralContextProvider>
      </ThemeProvider>
    </ConfigProvider>
  )
}

export default App
